import React, {useEffect} from 'react';
import * as Templates from './templates';
import Stories from '../stories/Stories/Stories';
import * as Story from '../stories';
import { checkNested } from 'components/utils/helper';
import { useLocation } from 'react-router-dom';

const DynamicPage = ({ cms, content, page, componentList }) => {
   let location = useLocation();

   useEffect(() => {
      // Set title tag by page title on location changed.
      document.title = getDocumentTitle(cms,content,location);
   }, [location]);
   
   function renderPage() {  
      switch(page){
         case "stories":
            return renderStories();
         case "story":
            return renderStory();
         case "content":
            return renderContent();
         default:
            return renderDefault(); 
      }
   }

   function renderStories() {
      return <Stories
         cms={cms}
         articles={componentList}
      />
   }

   function renderStory() {
     if(componentList.length === 1){
        const componentObj = cms.components[componentList[0]];
        let components = { id: componentList[0], title: content.title, url: content.url, ...componentObj };
        return <Story.Article
            cms={cms}
            components={components}
         />
     }
   }

   function renderContent() {
      if(componentList.length === 1){
         const componentObj = cms.components[componentList[0]];
         return componentObj.components.map((component, i) =>  
            <div key={component.type + i}>{getComponent(component)}</div>
         );
      }
   }

   function renderDefault() {
      return componentList.map((componentId, index) =>
         <div key={componentId + index}>{getComponent(componentId)}</div>
      );
   }

   function getDocumentTitle(cms, content, location) {
      let docTitle = "";
      if(location.pathname === '/' || location.pathname === '/index'){
         // Home page
         docTitle = checkNested(cms, 'siteSettings', 'metadata', 'title') ? cms.siteSettings.metadata.title : docTitle;
      } else {
         if(content && content.title){
            docTitle = checkNested(cms, 'components', content.components[0], 'metadata', 'metaTitle') ? cms.components[content.components[0]].metadata.metaTitle : content.title;
         }
      }
      return `${docTitle} ${docTitle.length > 0 ? ' - Movember' : 'Movember'}`;
   }

   function getComponent(componentObj) {
      switch (componentObj.type.toLowerCase()) {
         case "herovideo":
            return <Templates.HeroVideo {...componentObj} />
         case 'getinvolved':
            return <Templates.GetInvolved {...componentObj} />
         case 'programcarousel':
            return <Templates.ProgramCarousel {...componentObj} />
         case 'autoplaycarousel':
            return <Templates.AutoplayCarousel {...componentObj}/>
         case 'socialproof':
            return <Templates.SocialProof {...componentObj} />
         case 'marquee':
            return <Templates.Marquee {...componentObj} />
         case 'twocolumnblock':
            return <Templates.Block2Column {...componentObj} />
         case 'richtextblock':
            return <Templates.RichTextBlock {...componentObj} />
         default:
            return null;
      }
   }

   return (
      <React.Fragment>
         {renderPage()}
      </React.Fragment>
   );
}
 
export default DynamicPage;
